import React, { useEffect, useState } from 'react';
import '../../styles/globals.css'
import { Box, Button, Checkbox, CircularProgress, Grid, Input, InputLabel, Link, TextField, Typography } from '@mui/material'

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import karmaStyles from '../../styles/KarmaPool.module.css'
import CauseCardComponent from './causes/CauseCardComponent';
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import DashboardLogoutFooterComponent from './footer/DashboardLogoutFooterComponent';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';
import CycleTimer from './cycles/CycleTimer';
import CycleAllocatedTokens from './cycles/CycleAllocatedTokens';
import CauseSummaryCardComponent from './causes/CauseSummaryCardComponent';
import NoteComponent from './social/notes/NoteComponent';
import DashboardBackButtonComponent from './footer/DashboardBackButtonComponent';

import ProfilePictureDefault from '../../images/profile_pictures/default.png';
import { SystemSecurityUpdate } from '@mui/icons-material';

function DisplayProfile(userId) {
    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "1.0rem" }}>
            <Typography variant="body2" component="div" gutterBottom>
                {userId}
            </Typography>
        </Box>
    );
}

function DisplayNoteGrid({ latestNotes }) {
    return (
        <Box sx={{ marginBottom: "1.0rem", width: "100%", display: "flex", justifyContent: "center" }}>
            <Grid container spacing={2}>
                {latestNotes != null && latestNotes.length > 0 ? (
                    <>
                        {latestNotes.map((note) => {
                            return (
                                <Grid item key={note.id} xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                    <NoteComponent note={note} />
                                </Grid>
                            );
                        })}
                    </>) :
                    (
                        <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            {latestNotes == null ? "Loading.." : "Empty :'("}
                        </Grid>
                    )}
            </Grid>
        </Box>
    );
}

function ImageUpload(props) {

    const karmaContext = useKarmaPoolContext();

    const [uploadingImage, setUploadingImage] = useState(false);

    const [uploadUrl, setUploadUrl] = useState(null);

    const [selectedImage, setSelectedImage] = useState(null);

    const [imageId, setImageId] = useState(null);

    const [uploadError, setUploadError] = useState(null);

    function getCDNUploadUrlFromServer(file) {
        setUploadError(null); // Clear any previous errors
        
        karmaContext.profilePictureManager.getUploadLink(
            (data) => {
                // Success callback
                console.log("Got upload link: " + data.result.uploadURL);
                setUploadUrl(data.result.uploadURL);
                setImageId(data.result.id);

                console.log("Uploading image: " + file.name + " to: " + data.result.uploadURL);

                // upload image to CDN
                const formData = new FormData();
                formData.append('file', file);
                fetch(data.result.uploadURL, {
                    method: 'POST',
                    body: formData
                }).then((response) => {
                    if (!response.ok) {
                        throw new Error('Failed to upload image to CDN');
                    }
                    console.log("Image upload response: " + response);
                    karmaContext.profilePictureManager.confirmImageUploaded(data.result.id)

                    // Refresh page
                    window.location.reload();
                }).catch((error) => {
                    console.error("Image upload error: " + error);
                    setUploadError("Failed to upload image. Please try again.");
                    setUploadingImage(false);
                });
            },
            (error) => {
                // Error callback
                console.error("Failed to get upload link:", error);
                setUploadError("Server error: Unable to get upload link. Please try again later.");
                setUploadingImage(false);
            }
        );
    }

    function selectFile(event) {
        setUploadingImage(true);
        setUploadError(null);
        console.log("Selected file: " + event.target.files[0]);
        getCDNUploadUrlFromServer(event.target.files[0]);
    }

    if (uploadingImage) {
        return (
            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginBottom: "2.45rem", marginTop: "0.275rem" }} >
                <CircularProgress variant="indeterminate" color="inherit" size="1.5rem" />
            </Box>
        );
    }
    else {
        return (
            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginBottom: "2.45rem", marginTop: "0.275rem" }} >
                {uploadError && (
                    <Typography variant="caption" sx={{ marginBottom: "0.75rem", color: "#ff5252", textAlign: "center", maxWidth: "20rem" }}>
                        {uploadError}
                    </Typography>
                )}
                <Input disableUnderline={true}
                    label="Profile Picture"
                    type="file" id="profilePictureInput" onChange={selectFile}
                    sx={{
                        width: "6rem", display: "flex", justifyContent: "center",
                        ':before': { borderBottomColor: 'none' },
                        ':after': { borderBottomColor: 'none' },
                        alignItems: "center", textDecoration: 'none'
                    }} >
                    <InputLabel htmlFor="profilePictureInput">
                        Upload Profile Picture
                    </InputLabel>
                </Input>
            </Box>
        );
    }

}

function FollowButton(props) {

    const karmaContext = useKarmaPoolContext();

    if (props.profile === null || props.profile === undefined) {
        return (
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "2.45rem", marginTop: "0.275rem" }} >
                <Link onClick={() => { }}>
                    <Typography variant="body2" component="div" gutterBottom sx={{}}>
                        follow
                    </Typography>
                </Link>
            </Box>
        );
    }
    else if (props.profile.following) {
        return (
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "2.45rem", marginTop: "0.275rem" }} >
                <Link onClick={() => {
                    karmaContext.profileManager.unfollow(props.profile.id);
                    props.setProfile({ ...props.profile, followerCount: props.profile.followerCount-1, following: false })
                }}>
                    <Typography variant="body2" component="div" gutterBottom sx={{ fontSize: "0.9rem" }}>
                        following
                    </Typography>
                </Link>
            </Box>
        );
    }
    else {
        return (
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "2.45rem", marginTop: "0.275rem" }} >
                <Link onClick={() => {
                    karmaContext.profileManager.follow(props.profile.id);
                    props.setProfile({ ...props.profile, followerCount: props.profile.followerCount+1, following: true })
                }}>
                    <Typography variant="body2" component="div" gutterBottom sx={{}}>
                        follow
                    </Typography>
                </Link>
            </Box>
        );
    }
}


function DashboardProfile() {

    const theme = useTheme();
    const isMediumScreenSize = useMediaQuery(theme.breakpoints.up('sm'));

    const karmaContext = useKarmaPoolContext();

    useEffect(() => {
        // get userId from profile?userId=123
        const urlParams = new URLSearchParams(window.location.search);
        const userId = urlParams.get('userId');

        console.log("userId: " + userId);

        karmaContext.noteManager.fetchProfileNotes(userId);
        karmaContext.profileManager.fetchUserById(userId);
    }, []);

    useEffect(() => {
        setProfileNotes(karmaContext.local.profileNotes);
    }, [karmaContext.local.profileNotes]);

    const [profileNotes, setProfileNotes] = useState(() => {
        return karmaContext.local.profileNotes;
    });

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const userId = urlParams.get('userId');

        if (karmaContext.local.profiles === undefined) {
            return;
        }

        setProfile(karmaContext.local.profiles[userId]);
    }, [karmaContext.local.profiles]);

    const [profile, setProfile] = useState(null);

    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    socialEnabled={true} />
            </Box>
            <Box className={karmaStyles.homepageBox3}>
                {/* Note Submission Form */}
                <Box sx={{ marginBottom: "1.0rem" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        Display Name: <strong> {profile != null && profile !== undefined && profile.username !== undefined ? profile.username : ""} </strong>
                        <br />
                        Followers: <strong>{profile != null && profile !== undefined && profile.followerCount !== undefined ? profile.followerCount : "0"}</strong>
                    </Typography>
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} >
                        <Box sx={{
                            width: "6rem",
                            height: "6rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "1rem",
                            marginBottom: "1rem",
                            backgroundColor: "#121212",
                        }} >
                            <img
                                src={profile !== null && profile !== undefined && profile.profilePictureImageId !== null ?
                                    "https://imagedelivery.net/VOV6-bP9OpL34z4U0gUIFw/" + profile.profilePictureImageId + "/profilepicture512" : ProfilePictureDefault}
                                alt="profile-pic" width={"96"} height={"96"} />

                        </Box>
                    </Box>

                    {profile != null && profile !== undefined &&
                        karmaContext.local.user != null && karmaContext.local.user.id === profile.id ? (<ImageUpload />) : (<FollowButton profile={profile} setProfile={setProfile} />)}

                </Box>

                <Box sx={{ marginBottom: "1.125rem" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        <strong> Recent Shares </strong>
                    </Typography>
                </Box>
                <DisplayNoteGrid latestNotes={profileNotes} />

            </Box>
            <DashboardBackButtonComponent urlSuffix={"social"} />
        </>
    );
}

export default DashboardProfile;